import {Vue} from "vue/types/vue";

type VueElement = Vue | Element | Vue[] | Element[];

export default class Animations {

    public static wait(duration:number):Promise<void> {
        return new Promise(resolve => window.setTimeout(resolve, 1000 * duration));
    }

    public static fadeIn(vue:VueElement, duration:number = 1.5):Promise<void> {
        return this.animate(vue, 'fadeIn', duration);
        // let el:HTMLElement = <HTMLElement> vue;
        // el.classList.remove('fadeout');
        // el.style.animationDuration = duration + 's';
        // el.classList.add('fadein');
        // return new Promise(resolve => window.setTimeout(resolve, 1000 * duration));
    }

    public static fadeOut(vue:VueElement, duration:number = 1.5):Promise<void> {
        return this.animate(vue, 'fadeOut', duration);
        // let el:HTMLElement = <HTMLElement> vue;
        // el.classList.remove('fadein');
        // el.style.animationDuration = duration + 's';
        // el.classList.add('fadeout');
        // return new Promise(resolve => window.setTimeout(resolve, 1000 * duration));
    }

    public static fadeHide(vue:VueElement):void {
        let el:HTMLElement = <HTMLElement> vue;
        el.style.visibility = 'hidden';
        el.style.opacity = '0';
    }

    public static slideFromLeft(vue:VueElement, duration:number = 1.5):Promise<void> {
        return this.animate(vue, 'slideFromLeft', duration);
    }

    public static slideToLeft(vue:VueElement, duration:number = 1.5):Promise<void> {
        return this.animate(vue, 'slideToLeft', duration);
    }

    public static slideFromRight(vue:VueElement, duration:number = 1.5):Promise<void> {
        return this.animate(vue, 'slideFromRight', duration);
    }

    public static slideToRight(vue:VueElement, duration:number = 1.5):Promise<void> {
        return this.animate(vue, 'slideToRight', duration);
    }

    public static animate(vue:VueElement, animationName:string, duration:number):Promise<void> {
        let el:HTMLElement = <HTMLElement> vue;
        el.style.animationDuration = duration + 's';
        el.style.animationName = animationName;
        return new Promise(resolve => window.setTimeout(resolve, 1000 * duration));
    }
}